export const taxi = (state) => state.taxi;

export const taxiList = (state) => state.taxiList;

export const taxiFilterList = (state) => state.taxiFilterList;

export const getTaxiBalance = (state) => state.taxi.balance;

export const getTaxiSignatureData = (state) => state.taxiSignatureData;
